export default __webpack_public_path__ + "static/media/right-forgot.38e2ed2d.png";